<script setup>
import { computed } from 'vue';

const props = defineProps({
  attribute: {
    type: Object,
    required: true,
  },
  loading: {
    type: Boolean,
    default: false,
  },
});

const emit = defineEmits(['edit', 'delete']);

const displayName = computed(() => props.attribute.attribute_display_name || '');
const description = computed(() => props.attribute.attribute_description || '');
const displayType = computed(() => props.attribute.attribute_display_type || '');
const keyValue = computed(() => props.attribute.attribute_key || '');

function onEdit() {
  emit('edit', props.attribute);
}
function onDelete() {
  emit('delete', props.attribute);
}
</script>

<template>
  <div
    class="rounded-lg border border-n-gray-2 bg-n-gray-1 dark:border-n-vars-black-bd/80 dark:bg-n-vars-black-br/30 p-3 w-full text-n-gray-3"
  >
    <!-- Top: Name + actions -->
    <div class="flex items-start justify-between gap-2 mb-2">
      <div class="min-w-0">
        <h6 class="block font-semibold text-sm text-n-gray-7 dark:text-n-gray-3 truncate">
          {{ displayName }}
        </h6>
        <p class="text-xs text-n-gray-5 truncate">
          {{ description || '—' }}
        </p>
      </div>
      <div class="flex gap-1 flex-shrink-0">
        <woot-button
          v-tooltip.bottom="$t('ATTRIBUTES_MGMT.LIST.BUTTONS.EDIT')"
          variant="smooth"
          size="small"
          icon="edit"
          class-names="!bg-n-gray-25 !text-n-gray-5 !border-n-gray-1 dark:!border-n-vars-black-bd/80 dark:!bg-n-vars-black-bd/80 dark:!text-n-gray-3 !rounded-lg !w-8 !h-8 !p-0"
          :is-loading="loading"
          @click="onEdit"
        />
        <woot-button
          v-tooltip.bottom="$t('ATTRIBUTES_MGMT.LIST.BUTTONS.DELETE')"
          variant="smooth"
          size="small"
          icon="dismiss-circle"
          class-names="!bg-n-gray-25 !text-n-gray-5 !border-n-gray-1 dark:!border-n-vars-black-bd/80 dark:!bg-n-vars-black-bd/80 dark:!text-n-gray-3 !rounded-lg !w-8 !h-8 !p-0"
          :is-loading="loading"
          @click="onDelete"
        />
      </div>
    </div>

    <!-- Middle rows -->
    <div class="flex items-center justify-between mb-2">
      <div class="text-xs text-n-gray-5">
        {{ $t('ATTRIBUTES_MGMT.LIST.TABLE_HEADER.TYPE') }}
      </div>
      <div class="text-xs font-medium text-n-gray-6 dark:text-n-gray-3">
        {{ displayType || '—' }}
      </div>
    </div>

    <div class="flex items-center justify-between">
      <div class="text-xs text-n-gray-5">
        {{ $t('ATTRIBUTES_MGMT.LIST.TABLE_HEADER.KEY') }}
      </div>
      <div class="text-xs font-medium text-n-gray-6 dark:text-n-gray-3 font-mono truncate max-w-[60%]">
        {{ keyValue || '—' }}
      </div>
    </div>
  </div>
</template>